import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Zoom,
} from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../OptionsBoardStyles';
import { Link } from 'react-router-dom';
import { setOptionChainAction } from '../../../actions/optionChainAction';

const ModalTable = ({
  setWatchListData,
  openOICall,
  toggleModal,
  toggleOICell,
  rows
}) => {
  const dispatch = useDispatch();
  const { appReducer, optionChainReducer } = useSelector((state) => state);
  const { isMobile, targetPrice, quoteInfo } = appReducer;
  const { latestPrice } = quoteInfo
  const { favioute, putRows, hideShading, check } = optionChainReducer;

  const setOptionChainState = (payload) =>
    dispatch(setOptionChainAction(payload));

  const setCheckedValue = (index, data) => {
    let newCh = JSON.parse(JSON.stringify(check));
    newCh[index].value = !check[index].value;
    setOptionChainState({ check: newCh });
    setWatchListData(data, index);
  };

  const topPosition = !isMobile ? '91px' : '50px';

  return (
    <Table style={styles.tableContainer}>
      <TableHead>
        {!isMobile && (
          <TableRow style={styles.tableRow}>
            {favioute && check.length && (
              <TableCell
                style={{
                  ...styles.tableHeaderCell,
                  top: topPosition,
                }}
                className="sticky"
              ></TableCell>
            )}

            <Tooltip
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 700 }}
              placement="top"
              PopperProps={{
                style: styles.tooltip,
              }}
              title="The Risk Reward Breakeven Price shows the market’s expected Stock Price AT EXPIRATION that equalizes the risk and reward of the option."
            >
              <TableCell
                style={{
                  ...styles.RRHeaderCell,
                  top: topPosition,
                }}
                className="sticky"
              >
                RR$
              </TableCell>
            </Tooltip>
            <TableCell
              style={{
                ...styles.tableHeaderCell,
                top: topPosition,
              }}
              className="sticky"
            >
              Bid
            </TableCell>
            <TableCell
              style={{
                ...styles.tableHeaderCell,
                top: topPosition,
              }}
              className="sticky"
            >
              Ask
            </TableCell>
            <TableCell
              style={{
                ...styles.tableHeaderCell,
                top: topPosition,
              }}
              className="sticky"
            >
              Volume
            </TableCell>

            <TableCell
              style={{
                ...styles.tableHeaderCell,
                top: topPosition,
                cursor: "pointer",
              }}
              className="sticky"
            >
              <Link
                onClick={() => openOICall()}
                style={{ color: "blue" }}
                to="/openinterest"
              >
                OI
              </Link>
            </TableCell>
            <TableCell
              style={{
                ...styles.strikeHeaderCell,
                top: topPosition,
              }}
              className="sticky"
            >
              Strike
            </TableCell>
          </TableRow>
        )}
        {isMobile && (
          <TableRow style={styles.tableRow}>
            {favioute && (
              <TableCell
                style={{
                  ...styles.tableHeaderCell,
                  top: topPosition,
                }}
                className="sticky"
              ></TableCell>
            )}

            <TableCell
              style={{
                ...styles.tableHeaderCell,
                top: topPosition,
              }}
              className="sticky"
            >
              Volume
            </TableCell>
            <TableCell
              style={{
                ...styles.tableHeaderCell,
                top: topPosition,
              }}
              className="sticky"
            >
              Bid
            </TableCell>
            <TableCell
              style={{
                ...styles.tableHeaderCell,
                top: topPosition,
              }}
              className="sticky"
            >
              Ask
            </TableCell>

            <TableCell
              style={{
                ...styles.strikeHeaderCell,
                top: topPosition,
              }}
              className="sticky"
            >
              Strike
            </TableCell>
          </TableRow>
        )}
        {null}
      </TableHead>
      <TableBody>
        {rows.map((row, index) => {
          const itm = row.itm;
          const putItm = putRows[index] ? putRows[index].itm : 0;
          const noTargetPrice = !targetPrice || targetPrice * 1 === 0;

          // Shade row or not.  Used to determine whether to shade strike cell as well.
          const shadeRow =
            (targetPrice > latestPrice &&
              (itm >= 0.4549 || itm <= 0.245)) ||
            (targetPrice < latestPrice && !noTargetPrice) ||
            (noTargetPrice && (itm >= 0.4549 || itm <= 0.245));
          // Need to do this because don't shade strike if put side is active and this strike itm

          const shadeStrikeCell =
            shadeRow &&
            ((targetPrice < latestPrice &&
              (putItm >= 0.4549 || putItm <= 0.245)) ||
              (targetPrice > latestPrice &&
                (itm >= 0.4549 || itm <= 0.245)));


          return !isMobile ?
            (
              <TableRow
                ref={row.reference}
                key={index}
                style={
                  !hideShading && shadeRow
                    ? styles.shadedRow
                    : styles.tableRow
                }
              >
                {favioute && check.length > 0 && (
                  <TableCell
                    colSpan={1}
                    style={
                      styles.shadedTableCell
                    }
                  >
                    <Checkbox
                      checked={check[index].value}
                      style={{ height: "5px", color: "darkgray" }}
                      onClick={() => setCheckedValue(index, row)}
                    />
                  </TableCell>
                )}

                <TableCell
                  style={
                    !hideShading && shadeRow
                      ? styles.shadedRRCell
                      : styles.RRCell
                  }
                >
                  {!row.RR ? "NA" : row.RR.toFixed(2)}
                </TableCell>

                {!isMobile && (
                  <TableCell
                    style={
                      !hideShading && shadeRow
                        ? styles.shadedTableCell
                        : styles.tableCell
                    }
                  >
                    {row.theo_bid.toFixed(2)}
                  </TableCell>
                )}

                {!isMobile && (
                  <TableCell
                    style={
                      !hideShading && shadeRow
                        ? styles.shadedTableCell
                        : styles.tableCell
                    }
                  >
                    {row.theo_ask && row.theo_ask.toFixed(2)}
                  </TableCell>
                )}

                <TableCell
                  style={
                    !hideShading && shadeRow
                      ? styles.shadedTableCellClickable
                      : styles.tableCellClickable
                  }
                  className="toggleCell"
                  onClick={() =>
                    toggleModal(row)
                  }
                >
                  {row.volume.toString().replace(
                    // Adds commas for thousands
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )}
                </TableCell>
                <TableCell
                  className="toggleCellsOI"
                  style={
                    !hideShading && shadeRow
                      ? styles.shadedTableCellClickableOI
                      : styles.tableCellClicKableOI
                  }
                  onClick={() => toggleOICell(row)}
                >
                  {row.open_int.toString().replace(
                    // Adds commas for thousands
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )}
                </TableCell>

                <TableCell
                  style={
                    !hideShading && shadeStrikeCell
                      ? styles.shadedStrikeCell
                      : styles.strikeCell
                  }
                  onClick={() => setWatchListData(true, index, row)}
                >
                  {row.strike.toFixed(2)}
                </TableCell>
              </TableRow>
            ) : (
              <TableRow
                ref={row.reference}
                key={index}
                style={
                  !hideShading && shadeRow
                    ? styles.shadedRow
                    : styles.tableRow
                }
              >
                {favioute && check.length && (
                  <TableCell
                    colSpan={1}
                    style={
                      { ...styles.shadedTableCell, paddingLeft: "15px" }
                    }
                  >
                    <Checkbox
                      checked={check[index].value}
                      style={{ height: "5px", color: "darkgray" }}
                      onClick={() => setCheckedValue(index, row)}
                    />
                  </TableCell>
                )}

                <TableCell
                  style={
                    !hideShading && shadeRow
                      ? styles.shadedTableCellClickableMobile
                      : styles.tableCellClickableMobile
                  }
                  className="toggleCell"
                  onClick={() => {
                    toggleModal(row);
                  }}
                >
                  {row.volume.toString().replace(
                    // Adds commas for thousands
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )}
                </TableCell>
                <TableCell
                  style={
                    !hideShading && shadeRow
                      ? styles.shadedTableCell
                      : styles.tableCell
                  }
                >
                  {row.theo_bid.toFixed(2)}
                </TableCell>
                <TableCell
                  style={
                    !hideShading && shadeRow
                      ? styles.shadedTableCell
                      : styles.tableCell
                  }
                >
                  {row.theo_ask && row.theo_ask.toFixed(2)}
                </TableCell>
                <TableCell
                  style={
                    !hideShading && shadeStrikeCell
                      ? styles.shadedStrikeCell
                      : styles.strikeCell
                  }
                >
                  {row.strike.toFixed(2)}
                </TableCell>
              </TableRow>
            );
        })}
      </TableBody>
    </Table>
  );
};

export default ModalTable;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BasicCallBoard/Table.jsx